<div class="main-container">
  <p class="header" i18n="@@PendingTasks" t="PendingTasks">Pending Tasks</p>
  <div *ngIf="requestList?.length; else noList" class="request-list-container">
      <ng-container *ngFor="let request of requestList">
          <div class="request-item">
              <div class="request-type-container">
                 <div>
                    <div *ngIf="(!isPCFUploaded && !showMFADialog) || isPCFValidationInProgress" tslTooltip="{{translate.get(isContactValidationPendingTaskErrorMessage)}}">
                        <p [ngClass]="{'link-disable': true}" (click)="openTasks(request)">{{ translate.get(request.requestTypeDisplay) }}</p>
                    </div>
                    <div  *ngIf="!((!isPCFUploaded && !showMFADialog) || isPCFValidationInProgress)">
                        <a (click)="openTasks(request)">{{ translate.get(request.requestTypeDisplay) }}</a>
                    </div>
                 </div>
                  <button *ngIf="request.allowedActions?.length" tsl-icon-button size="medium" [tslContextMenuTriggerFor]="menu">
                      <tsl-icon>more_vert</tsl-icon>
                  </button>
                  <tsl-context-menu #menu="tslContextMenu" width="content" [overlapTrigger]="false">
                      <button *ngIf="request.allowedActions.includes('view')" i18n="@@View" t="View" (click)="openRequest(request.requestId, request.requestType, 'view')" tsl-context-menu-item>View</button>
                      <button *ngIf="request.allowedActions.includes('edit')" i18n="@@Edit" t="Edit" (click)="openRequest(request.requestId, request.requestType, 'edit')" tsl-context-menu-item>Edit</button>
                      <button *ngIf="request.allowedActions.includes('delete')" i18n="@@Cancel" t="Cancel" (click)="cancelRequest(request.requestId, request.requestType)" tsl-context-menu-item>Cancel</button>
                  </tsl-context-menu>
              </div>
              <p class="line-item"><span i18n="@@DueDate:" t="DueDate:">Due Date: </span><span>{{ translate.get(request.overallDueDate) | date:
                'longDate':'':(language == "no-NO" ? "nn" : language)}}</span></p>
              <p class="line-item"><span i18n="@@Status:" t="Status:">Status: </span><span>{{ translate.get(request.status) }}</span></p>
              <p class="line-item"><span i18n="@@Progress:" t="Progress:">Progress: </span><span>{{ request.progress }}%</span></p>
          </div>
      </ng-container>
  </div>
  <ng-template #noList>
      <p class="no-task-message" i18n="@@NoPendingTask" t="NoPendingTask">No Pending Task</p>
  </ng-template>
</div>